<template>
    <MainHeader v-if="menu" :menu />
    <SubHeader v-if="menu?.secondaryMenu || isMobile" :items="menu?.secondaryMenu || []" />
    <div class="header-gradient" v-if="headerStore.backgroundImage && isMobile">
        <div class="header-gradient__bottom"></div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, watch } from "vue";
import MainHeader from "@/header/components/molecules/MainHeader.vue";
import SubHeader from "@/header/components/molecules/SubHeader.vue";
import { useHeader } from "@/shared/stores/use-header";
import useIsBreakpoint from "@/shared/composables/use-is-breakpoint";
import useNavigation from "@/shared/composables/use-navigation";

const { isMobile } = useIsBreakpoint();
const { menu, fillSubnav } = useNavigation();

const headerStore = useHeader();

const headerWrapper = document.querySelector<HTMLElement>("#header");

onMounted(async () => {
    await fillSubnav();
});

watch([() => headerStore.transparent, isMobile], ([headerTransparent, newIsMobile]) => {
    headerWrapper.classList.toggle("header--transparent", headerTransparent && newIsMobile);
});

watch([() => headerStore.backgroundImage, isMobile], ([headerBackgroundImage, newIsMobile]) => {
    headerWrapper.style.backgroundImage = headerBackgroundImage && newIsMobile ? headerBackgroundImage : null;
});
</script>
